const DocumentTypes = Object.freeze({
    MY_UPLOAD: 1,
    RECEIVED: 2,
  });
  
  export default DocumentTypes;
  